/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../index.js";
export function IconDeviceCar(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M2.92 2.375A2.75 2.75 0 0 1 5.303 1h5.395c.983 0 1.89.524 2.382 1.375L14.017 4h1.233a.75.75 0 0 1 0 1.5h-.237c.989.9.988 2.117.987 2.707v7.043a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1-.75-.75V14H3v1.25a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75V8.207C0 7.617-.002 6.4.987 5.5H.75a.75.75 0 0 1 0-1.5h1.233l.938-1.625zm2.382.125c-.446 0-.859.238-1.082.625L3.137 5h9.726L11.78 3.125a1.25 1.25 0 0 0-1.083-.625H5.302zm8.57 4H2.128a2.72 2.72 0 0 1-.055.046c-.473.377-.556.894-.57 1.454h2.429a1 1 0 0 1 1 1v.5H1.5v3h13v-3h-3.43V9a1 1 0 0 1 1-1h2.427c-.013-.56-.096-1.077-.569-1.454a2.585 2.585 0 0 1-.055-.046z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M12 19c2.036 0 4.039-.142 6-.415V20.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V10.45c0-1.49-.83-2.785-2.05-3.45H23a1 1 0 1 0 0-2h-2.405l-.866-1.5A5 5 0 0 0 15.4 1H8.601a5 5 0 0 0-4.33 2.5L3.405 5H1a1 1 0 0 0 0 2h1.05A3.925 3.925 0 0 0 0 10.45V20.5A1.5 1.5 0 0 0 1.5 22h3A1.5 1.5 0 0 0 6 20.5v-1.915c1.961.273 3.964.415 6 .415zM6.003 4.5A3 3 0 0 1 8.6 3h6.798a3 3 0 0 1 2.598 1.5l1.346 2.331A40.23 40.23 0 0 1 12 7.504c-2.51 0-4.963-.231-7.343-.673L6.003 4.5zM12 9.504a42.17 42.17 0 0 0 8.652-.893l.018.006a1.93 1.93 0 0 1 1.317 1.605c-.045.049-.12.115-.241.196-.249.163-.604.324-1.048.47-.885.293-1.955.474-2.797.558a1 1 0 1 0 .198 1.99c.93-.092 2.155-.294 3.226-.648.227-.075.454-.16.675-.254v3.238A41.282 41.282 0 0 1 12 17a41.282 41.282 0 0 1-10-1.228v-3.238c.221.095.448.179.675.254 1.07.354 2.297.556 3.226.649a1 1 0 0 0 .198-1.99c-.842-.085-1.912-.266-2.797-.558-.443-.147-.8-.308-1.048-.471a1.319 1.319 0 0 1-.24-.195A1.93 1.93 0 0 1 3.33 8.617l.018-.006A42.17 42.17 0 0 0 12 9.504zm8 8.753a43.78 43.78 0 0 0 2-.426V20h-2v-1.743zm-18-.426c.66.157 1.328.3 2 .426V20H2v-2.17z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconDeviceCar is deprecated and will be archived soon. Use IconDeviceCar instead.
 */
export function Experimental__IconDeviceCar(props) {
  return /*#__PURE__*/React.createElement(IconDeviceCar, props);
}